(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('EventForm', EventForm);

    EventForm.$inject = ['$resource', 'DateUtils', '$http', '$q'];

    function EventForm ($resource, DateUtils, $http, $q) {
        var resourceUrl =  'api/form-event/:id';

        var resource = $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateRecord = DateUtils.convertDateTimeFromServer(data.dateRecord);
                    return data;
                }
            },
            'history': {
                method: 'GET',
                isArray: true,
                url: 'api/form-event/:id/history'
            },
            'bulkStatus': { method: 'POST', url: 'api/form-event/bulk-status' },
            'update': { method:'PUT'}
        });

        resource.validateDocument = function(params, success, error) {
            return postAction(buildActionUrl(params, 'validate'), success, error);
        };

        resource.controlDocument = function(params, success, error) {
            return postAction(buildActionUrl(params, 'control'), success, error);
        };

        resource.createTicket = function(params, success, error) {
            return postAction(buildActionUrl(params, 'create-ticket'), success, error);
        };

        return resource;

        function buildActionUrl(params, actionName) {
            var eventId = params && params.id ? params.id : null;
            if (!eventId) {
                throw new Error('Identifiant de l’événement manquant.');
            }
            return 'api/form-event/' + encodeURIComponent(eventId) + '/' + actionName;
        }

        function postAction(url, success, error) {
            return $http.post(url).then(function(response) {
                if (angular.isFunction(success)) {
                    success(response.data, response.headers);
                }
                return response.data;
            }, function(response) {
                if (angular.isFunction(error)) {
                    error(response);
                }
                return $q.reject(response);
            });
        }
    }
})();
